import { useEffect, useState } from "react";

export type LayoutStyle = "compact" | "classic" | "colorful";

const LS_KEY = "bd:layout:style";
const DEFAULT: LayoutStyle = "compact";

function readStored(): LayoutStyle {
  if (typeof window === "undefined") return DEFAULT;
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw === "compact" || raw === "classic" || raw === "colorful") {
      return raw;
    }
  } catch {
    // noop
  }
  return DEFAULT;
}

/**
 * Hook reativo pro estilo de layout do menu principal. Persiste em
 * localStorage + escuta o evento 'storage' pra sincronizar entre abas.
 */
export function useLayoutStyle(): [LayoutStyle, (s: LayoutStyle) => void] {
  const [style, setStyleState] = useState<LayoutStyle>(readStored);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const onStorage = (e: StorageEvent) => {
      if (e.key === LS_KEY) setStyleState(readStored());
    };
    const onCustom = () => setStyleState(readStored());
    window.addEventListener("storage", onStorage);
    window.addEventListener("bd:layout-style-change", onCustom);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("bd:layout-style-change", onCustom);
    };
  }, []);

  const setStyle = (s: LayoutStyle) => {
    try {
      localStorage.setItem(LS_KEY, s);
    } catch {
      // noop
    }
    setStyleState(s);
    // Evento customizado pra sincronizar múltiplos componentes na MESMA aba.
    window.dispatchEvent(new Event("bd:layout-style-change"));
  };

  return [style, setStyle];
}
